export default "__VITE_ASSET__B7nxW0nS__"